import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AttractionsCarousel from '../components/AttractionsCarousel';
import HeroSection from '../components/HeroSection';
import PricingSection from '../components/PricingSection';
import ContactSection from '../components/ContactSection';
import LocationSection from '../components/LocationSection';

export default function LandingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(location.state?.registrationSuccess || '');

  useEffect(() => {
    if (!location.state?.registrationSuccess) {
      return;
    }

    setSuccessMessage(location.state.registrationSuccess);
    navigate(location.pathname, { replace: true, state: {} });

    const timeoutId = window.setTimeout(() => setSuccessMessage(''), 3200);
    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.state, navigate]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-tr from-white via-blue-50 to-blue-100">
      <div className="absolute top-[-100px] left-[-80px] w-[200px] h-[200px] bg-pink-300 rounded-full opacity-20 blur-2xl z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[250px] h-[250px] bg-yellow-200 rounded-full opacity-30 blur-2xl z-0" />
      <div className="relative z-10">
        {successMessage && (
          <div className="px-4 pt-24 md:px-6 md:pt-28">
            <div className="mx-auto max-w-5xl rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4 text-center shadow-[0_12px_30px_rgba(16,185,129,0.10)]">
              <p className="text-base font-semibold text-emerald-700">Registrado correctamente</p>
              <p className="mt-1 text-sm text-emerald-600">Tu registro se ha guardado correctamente.</p>
            </div>
          </div>
        )}
        <HeroSection />
        <AttractionsCarousel />
        <PricingSection />
        <ContactSection />
        <LocationSection />
      </div>
    </div>
  );
}
